module.exports = __webpack_public_path__ + "static/media/Jawbreak-Serif.a66ceee1.otf";